import { useQueryDocumentsBySessionId } from '@/hooks/query/useQueryDocumentsBySessionId';
import {
  SessionDocumentPickerList as SessionDocumentPickerListView,
  type SessionDocumentPickerListProps,
} from '@heidi/agents';

/** Binds the document picker to the app's session-documents query. */
export const SessionDocumentPickerList = (
  props: SessionDocumentPickerListProps
): JSX.Element => (
  <SessionDocumentPickerListView
    {...props}
    useSessionDocuments={useQueryDocumentsBySessionId}
  />
);
